import { render, staticRenderFns } from "./MappedSusaTable.vue?vue&type=template&id=64b484e1&scoped=true"
import script from "./MappedSusaTable.vue?vue&type=script&lang=js"
export * from "./MappedSusaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b484e1",
  null
  
)

export default component.exports